// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-input-group__append,\n.el-input-group__prepend {\n  background-color: #1890ff !important;\n  color: #fff !important;\n  border-color: #1890ff !important;\n  border-radius: 0 4px 4px 0;\n}\n.block {\n  text-align: right;\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
